import { render } from "./subjectFusionInfo.vue?vue&type=template&id=5925596e&scoped=true"
import script from "./subjectFusionInfo.vue?vue&type=script&lang=js"
export * from "./subjectFusionInfo.vue?vue&type=script&lang=js"

import "./subjectFusionInfo.vue?vue&type=style&index=0&id=5925596e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5925596e"]])

export default __exports__